import React from 'react'
import { PropagateLoader } from 'react-spinners'

const OverlayLoader = () => {
    return (
        <>
            <div className="overlay-loader">
                <div className='d-flex justify-content-center align-items-center' style={{ height: "400px", width: "100%" }}>
                    <PropagateLoader />
                </div>
            </div>
        </>
    )
}

export default OverlayLoader